(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-editorial"] && !Shopify.designMode) return;
  try {
    
  function initialisePureArticles(root) {
    root.querySelectorAll('.pure-article').forEach(article => {
      const nav = article.querySelector('.pure-article__contents');
      const list = nav.querySelector('ul');
      list.replaceChildren();
      const headings = article.querySelectorAll('.pure-article__body h2');
      headings.forEach((heading,index) => {
        if (!heading.id) heading.id = article.id + '-chapter-' + (index + 1);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      nav.hidden = headings.length < 3;
      const prose = article.querySelector('.pure-article__prose');
      if (prose) {
        const paragraphs = Array.from(prose.children).filter(node => node.tagName === 'P');
        const margin = article.querySelector('.tpe-note-margin[data-align-paragraph]');
        const alignParagraph = Number(margin?.dataset.alignParagraph);
        if (margin && alignParagraph > 0 && paragraphs[alignParagraph - 1]) {
          const alignMargin = () => {
            const offset = window.matchMedia('(min-width:990px)').matches
              ? Math.max(0, paragraphs[alignParagraph - 1].getBoundingClientRect().top - margin.parentElement.getBoundingClientRect().top)
              : 0;
            margin.style.marginTop = Math.round(offset) + 'px';
          };
          requestAnimationFrame(alignMargin);
          new ResizeObserver(alignMargin).observe(prose);
          window.addEventListener('resize', alignMargin);
          document.fonts.ready.then(alignMargin);
        }
        const tails = new Map();
        article.querySelectorAll('[data-after-paragraph]').forEach(module => {
          const position = Number(module.dataset.afterParagraph);
          const paragraph = paragraphs[position - 1];
          if (!paragraph) return;
          const anchor = tails.get(paragraph) || paragraph;
          anchor.after(module);
          tails.set(paragraph, module);
        });
      }
    });
  }
  initialisePureArticles(document);
  document.addEventListener('shopify:section:load', event => initialisePureArticles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Open mega menu on hover
  document.addEventListener('DOMContentLoaded', function() {
    // Find all mega menu details elements
    const megaMenus = document.querySelectorAll('.mega-menu');
    
    megaMenus.forEach(function(menu) {
  const summary = menu.querySelector('summary');
  const content = menu.querySelector('.mega-menu__content');
  let closeTimeout;
  
  if (summary && content) {
    // Get the menu title for accessibility
    const menuTitle = summary.querySelector('span').textContent.trim();

    // Handle both click and keyboard interaction
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = !menu.open;
      menu.open = isOpen;
      summary.setAttribute('aria-expanded', isOpen);
      summary.setAttribute('aria-label', isOpen ? `Close ${menuTitle} menu` : `Expand ${menuTitle} menu`);
    });

    // Handle keyboard events (Enter and Space)
    summary.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isOpen = !menu.open;
        menu.open = isOpen;
        summary.setAttribute('aria-expanded', isOpen);
        summary.setAttribute('aria-label', isOpen ? `Close ${menuTitle} menu` : `Expand ${menuTitle} menu`);
      }
      if (e.key === 'Escape' && menu.open) {
        menu.open = false;
        summary.setAttribute('aria-expanded', false);
        summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
        summary.focus();
      }
    });
    
    // Add hover to open
    summary.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeout);
      menu.open = true;
      summary.setAttribute('aria-expanded', true);
      summary.setAttribute('aria-label', `Close ${menuTitle} menu`);
    });
    
    // Don't close immediately when leaving summary
    summary.addEventListener('mouseleave', function() {
      closeTimeout = setTimeout(function() {
        menu.open = false;
        summary.setAttribute('aria-expanded', false);
        summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
      }, 500);
    });
    
    // Keep open when hovering over content
    content.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeout);
      menu.open = true;
      summary.setAttribute('aria-expanded', true);
      summary.setAttribute('aria-label', `Close ${menuTitle} menu`);
    });
    
    // Close when leaving content
    content.addEventListener('mouseleave', function() {
      closeTimeout = setTimeout(function() {
        menu.open = false;
        summary.setAttribute('aria-expanded', false);
        summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
      }, 100);
    });

    // Close menu when focus moves outside
    menu.addEventListener('focusout', function(e) {
      setTimeout(() => {
        if (!menu.contains(document.activeElement)) {
          menu.open = false;
          summary.setAttribute('aria-expanded', false);
          summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
        }
      }, 100);
    });
  }
});
  });

//BACKDROP
document.addEventListener('DOMContentLoaded', function() {
  const backdrop = document.getElementById('mobile-backdrop');
  const menuButton = document.querySelector('.header__icon--menu');
  const searchButtons = document.querySelectorAll('.header__icon--search');
  
  if (!backdrop) return;
  
  function showBackdrop() {
  const backdrop = document.getElementById('mobile-backdrop');
  backdrop.classList.add('active');
}

function hideBackdrop() {
  const backdrop = document.getElementById('mobile-backdrop');
  backdrop.classList.remove('active');
}
  
  // Handle mobile menu
  if (menuButton) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-expanded') {
          const isExpanded = menuButton.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            showBackdrop();
          } else {
            hideBackdrop();
          }
        }
      });
    });
    observer.observe(menuButton, { attributes: true });
  }
  
  // Handle search modals
  searchButtons.forEach(function(searchButton) {
    const searchModal = searchButton.closest('details-modal');
    if (searchModal) {
      const details = searchModal.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function() {
          if (this.open) {
            showBackdrop();
          } else {
            hideBackdrop();
          }
        });
      }
    }
  });
});





// Clean trapFocus override (original working version)
document.addEventListener('DOMContentLoaded', function() {
  
  // Override the global trapFocus function
  if (window.trapFocus) {
    const originalTrapFocus = window.trapFocus;
    window.trapFocus = function(container, elementToFocus) {
      // Store current scroll position
      const currentScroll = window.pageYOffset;
      
      // Call original trapFocus function
      originalTrapFocus.call(this, container, elementToFocus);
      
      // Restore scroll position to prevent jumping
      window.scrollTo(0, currentScroll);
    };
  }
  
  // Override addTrapFocus for mobile menu submenus
  if (window.addTrapFocus) {
    const originalAddTrapFocus = window.addTrapFocus;
    window.addTrapFocus = function() {
      // Store current scroll position
      const currentScroll = window.pageYOffset;
      
      // Call original function
      const result = originalAddTrapFocus.apply(this, arguments);
      
      // Restore scroll position
      window.scrollTo(0, currentScroll);
      
      return result;
    };
  }
  
  // Override removeTrapFocus to prevent scroll when focus returns
  if (window.removeTrapFocus) {
    const originalRemoveTrapFocus = window.removeTrapFocus;
    window.removeTrapFocus = function(elementToFocus) {
      // Store current scroll position
      const currentScroll = window.pageYOffset;
      
      // Call original function
      const result = originalRemoveTrapFocus.call(this, elementToFocus);
      
      // Restore scroll position to prevent jumping
      window.scrollTo(0, currentScroll);
      
      return result;
    };
  }
});





  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.querySelector('pn-editorial-navigation')) return;
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.checkInitialPosition();

    }

    disconnectedCallback() {
      if (!this.onScrollHandler) return;
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    checkInitialPosition() {
  // Wait for header bounds to be calculated
  setTimeout(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.currentScrollTop = scrollTop;
    
    // If we're already scrolled past the header, hide it immediately
    if (scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
  }, 100);
}

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-editorial-home"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-v7'); if(!host) return;
 const shopping=host.querySelector('.pn-h7__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-h7__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.matches('.tpe-shop-card__why-heading,.pn-rationale-brand,.pn-rationale-title')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-h7__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-h7__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const label=document.createElement('p');label.className='pn-h7__why-label';label.textContent='WHY IT MADE THE EDIT';overlay.append(label);const p=document.createElement('p');p.className='pn-h7__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-h7__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

(()=>{
const root=document.getElementById('pn-editorial-home-v7');if(!root)return;
const shop=root.querySelector('.pn-h7__shopping'),dialog=root.querySelector('.pn-h7__wishlist-dialog'),list=dialog.querySelector('.pn-h7__wishlist-items'),status=dialog.querySelector('[role=status]');
const key='pn-wishlist-preview-v1';let items=[];try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))items=saved.filter(x=>x&&typeof x.url==='string'&&/^https?:/.test(x.url)&&typeof x.title==='string');}catch{}
const tools=document.createElement('div');tools.className='pn-h7__wishlist-tools';const open=document.createElement('button');open.type='button';open.className='pn-h7__wishlist-open';tools.append(open);root.querySelector('.pn-h7__shopping .pn-commerce__header')?.append(tools);
const persist=()=>{try{localStorage.setItem(key,JSON.stringify(items));status.textContent='';}catch{status.textContent='Your browser could not save this list. It will remain available while this page is open.';}};
const sync=()=>{const label='My Wishlist ('+items.length+')';if(open.textContent!==label)open.textContent=label;shop.querySelectorAll('.pn-h7__save').forEach(b=>{const yes=items.some(x=>x.url===b.dataset.url);b.setAttribute('aria-pressed',String(yes));b.setAttribute('aria-label',(yes?'Remove ':'Save ')+b.dataset.title+(yes?' from wishlist':' to wishlist'));});};
const render=()=>{list.replaceChildren();if(!items.length){const p=document.createElement('p');p.textContent='Save something you love using the bookmark on a shopping card.';list.append(p);}items.forEach(item=>{const a=document.createElement('article'),image=document.createElement('img'),body=document.createElement('div'),brand=document.createElement('p'),h=document.createElement('h3'),link=document.createElement('a'),price=document.createElement('p'),remove=document.createElement('button');image.src=item.image;image.alt=item.title;brand.textContent=item.brand;link.href=item.url;link.rel='sponsored noopener';link.textContent=item.title;h.append(link);price.textContent=item.price;remove.type='button';remove.textContent='Remove';remove.addEventListener('click',()=>{items=items.filter(x=>x.url!==item.url);persist();sync();render();});body.append(brand,h,price,remove);a.append(image,body);list.append(a);});};
dialog.querySelector('[data-pn-wishlist-letters]')?.addEventListener('click',()=>dialog.close());open.addEventListener('click',()=>{render();dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());
const enhance=()=>{shop.querySelectorAll('.tpe-shop-card').forEach(card=>{if(card.querySelector('.pn-h7__save'))return;const media=card.querySelector('.tpe-shop-card__media'),link=card.querySelector('.tpe-shop-card__destination, .pn-commerce-cta'),title=card.querySelector('h3')?.textContent.trim();if(!media||!link||!title)return;const b=document.createElement('button');b.type='button';b.className='pn-h7__save';b.dataset.url=link.href;b.dataset.title=title;b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4H19V21L12 17L5 21Z"/></svg>';b.addEventListener('click',()=>{if(items.some(x=>x.url===link.href))items=items.filter(x=>x.url!==link.href);else items.push({url:link.href,title,brand:card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent.trim()||'',price:card.querySelector('.tpe-shop-card__price')?.textContent.trim()||'',image:card.querySelector('img')?.src||''});persist();sync();});const bookmarkRow=document.createElement('div');bookmarkRow.className='pn-h7__bookmark-row';bookmarkRow.append(b);card.querySelector('.tpe-shop-card__copy')?.prepend(bookmarkRow);});sync();};
new MutationObserver(enhance).observe(shop,{childList:true,subtree:true});enhance();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-home-editorial-study"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-preview'); if(!host) return;
 const shopping=host.querySelector('.pn-hp__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-hp__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.classList.contains('tpe-shop-card__why-heading')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-hp__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-hp__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const p=document.createElement('p');p.className='pn-hp__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-hp__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-home-editorial-v3"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-v3'); if(!host) return;
 const shopping=host.querySelector('.pn-h3__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-h3__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.classList.contains('tpe-shop-card__why-heading')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-h3__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-h3__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const p=document.createElement('p');p.className='pn-h3__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-h3__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-home-editorial-v4"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-v4'); if(!host) return;
 const shopping=host.querySelector('.pn-h4__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-h4__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.classList.contains('tpe-shop-card__why-heading')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-h4__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-h4__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const p=document.createElement('p');p.className='pn-h4__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-h4__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

(()=>{
const root=document.getElementById('pn-editorial-home-v4');if(!root)return;
const shop=root.querySelector('.pn-h4__shopping'),dialog=root.querySelector('.pn-h4__wishlist-dialog'),list=dialog.querySelector('.pn-h4__wishlist-items'),status=dialog.querySelector('[role=status]');
const key='pn-wishlist-preview-v1';let items=[];try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))items=saved.filter(x=>x&&typeof x.url==='string'&&/^https?:/.test(x.url)&&typeof x.title==='string');}catch{}
const tools=document.createElement('div');tools.className='pn-h4__wishlist-tools';const open=document.createElement('button');open.type='button';open.className='pn-h4__wishlist-open';tools.append(open);shop.prepend(tools);
const persist=()=>{try{localStorage.setItem(key,JSON.stringify(items));status.textContent='';}catch{status.textContent='Your browser could not save this list. It will remain available while this page is open.';}};
const sync=()=>{const label='My Wishlist ('+items.length+')';if(open.textContent!==label)open.textContent=label;shop.querySelectorAll('.pn-h4__save').forEach(b=>{const yes=items.some(x=>x.url===b.dataset.url);b.setAttribute('aria-pressed',String(yes));b.setAttribute('aria-label',(yes?'Remove ':'Save ')+b.dataset.title+(yes?' from wishlist':' to wishlist'));});};
const render=()=>{list.replaceChildren();if(!items.length){const p=document.createElement('p');p.textContent='Save something you love using the bookmark on a shopping card.';list.append(p);}items.forEach(item=>{const a=document.createElement('article'),image=document.createElement('img'),body=document.createElement('div'),brand=document.createElement('p'),h=document.createElement('h3'),link=document.createElement('a'),price=document.createElement('p'),remove=document.createElement('button');image.src=item.image;image.alt=item.title;brand.textContent=item.brand;link.href=item.url;link.rel='sponsored noopener';link.textContent=item.title;h.append(link);price.textContent=item.price;remove.type='button';remove.textContent='Remove';remove.addEventListener('click',()=>{items=items.filter(x=>x.url!==item.url);persist();sync();render();});body.append(brand,h,price,remove);a.append(image,body);list.append(a);});};
open.addEventListener('click',()=>{render();dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());
const enhance=()=>{shop.querySelectorAll('.tpe-shop-card').forEach(card=>{if(card.querySelector('.pn-h4__save'))return;const media=card.querySelector('.tpe-shop-card__media'),link=card.querySelector('.tpe-shop-card__destination, .pn-commerce-cta'),title=card.querySelector('h3')?.textContent.trim();if(!media||!link||!title)return;const b=document.createElement('button');b.type='button';b.className='pn-h4__save';b.dataset.url=link.href;b.dataset.title=title;b.innerHTML='<svg viewBox="0 0 20 26" aria-hidden="true"><path d="M3 2h14v22l-7-5-7 5z"/></svg>';b.addEventListener('click',()=>{if(items.some(x=>x.url===link.href))items=items.filter(x=>x.url!==link.href);else items.push({url:link.href,title,brand:card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent.trim()||'',price:card.querySelector('.tpe-shop-card__price')?.textContent.trim()||'',image:card.querySelector('img')?.src||''});persist();sync();});media.append(b);});sync();};
new MutationObserver(enhance).observe(shop,{childList:true,subtree:true});enhance();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-home-editorial-v5"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-v5'); if(!host) return;
 const shopping=host.querySelector('.pn-h5__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-h5__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.classList.contains('tpe-shop-card__why-heading')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-h5__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-h5__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const p=document.createElement('p');p.className='pn-h5__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-h5__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

(()=>{
const root=document.getElementById('pn-editorial-home-v5');if(!root)return;
const shop=root.querySelector('.pn-h5__shopping'),dialog=root.querySelector('.pn-h5__wishlist-dialog'),list=dialog.querySelector('.pn-h5__wishlist-items'),status=dialog.querySelector('[role=status]');
const key='pn-wishlist-preview-v1';let items=[];try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))items=saved.filter(x=>x&&typeof x.url==='string'&&/^https?:/.test(x.url)&&typeof x.title==='string');}catch{}
const tools=document.createElement('div');tools.className='pn-h5__wishlist-tools';const open=document.createElement('button');open.type='button';open.className='pn-h5__wishlist-open';tools.append(open);root.querySelector('.pn-h5__shopping .pn-commerce__header')?.append(tools);
const persist=()=>{try{localStorage.setItem(key,JSON.stringify(items));status.textContent='';}catch{status.textContent='Your browser could not save this list. It will remain available while this page is open.';}};
const sync=()=>{const label='My Wishlist ('+items.length+')';if(open.textContent!==label)open.textContent=label;shop.querySelectorAll('.pn-h5__save').forEach(b=>{const yes=items.some(x=>x.url===b.dataset.url);b.setAttribute('aria-pressed',String(yes));b.setAttribute('aria-label',(yes?'Remove ':'Save ')+b.dataset.title+(yes?' from wishlist':' to wishlist'));});};
const render=()=>{list.replaceChildren();if(!items.length){const p=document.createElement('p');p.textContent='Save something you love using the bookmark on a shopping card.';list.append(p);}items.forEach(item=>{const a=document.createElement('article'),image=document.createElement('img'),body=document.createElement('div'),brand=document.createElement('p'),h=document.createElement('h3'),link=document.createElement('a'),price=document.createElement('p'),remove=document.createElement('button');image.src=item.image;image.alt=item.title;brand.textContent=item.brand;link.href=item.url;link.rel='sponsored noopener';link.textContent=item.title;h.append(link);price.textContent=item.price;remove.type='button';remove.textContent='Remove';remove.addEventListener('click',()=>{items=items.filter(x=>x.url!==item.url);persist();sync();render();});body.append(brand,h,price,remove);a.append(image,body);list.append(a);});};
open.addEventListener('click',()=>{render();dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());
const enhance=()=>{shop.querySelectorAll('.tpe-shop-card').forEach(card=>{if(card.querySelector('.pn-h5__save'))return;const media=card.querySelector('.tpe-shop-card__media'),link=card.querySelector('.tpe-shop-card__destination, .pn-commerce-cta'),title=card.querySelector('h3')?.textContent.trim();if(!media||!link||!title)return;const b=document.createElement('button');b.type='button';b.className='pn-h5__save';b.dataset.url=link.href;b.dataset.title=title;b.innerHTML='<svg viewBox="0 0 20 26" aria-hidden="true"><path d="M3 2h14v22l-7-5-7 5z"/></svg>';b.addEventListener('click',()=>{if(items.some(x=>x.url===link.href))items=items.filter(x=>x.url!==link.href);else items.push({url:link.href,title,brand:card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent.trim()||'',price:card.querySelector('.tpe-shop-card__price')?.textContent.trim()||'',image:card.querySelector('img')?.src||''});persist();sync();});card.querySelector('.tpe-shop-card__copy')?.append(b);});sync();};
new MutationObserver(enhance).observe(shop,{childList:true,subtree:true});enhance();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-home-editorial-v6"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-v6'); if(!host) return;
 const shopping=host.querySelector('.pn-h6__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-h6__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.classList.contains('tpe-shop-card__why-heading')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-h6__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-h6__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const p=document.createElement('p');p.className='pn-h6__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-h6__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

(()=>{
const root=document.getElementById('pn-editorial-home-v6');if(!root)return;
const shop=root.querySelector('.pn-h6__shopping'),dialog=root.querySelector('.pn-h6__wishlist-dialog'),list=dialog.querySelector('.pn-h6__wishlist-items'),status=dialog.querySelector('[role=status]');
const key='pn-wishlist-preview-v1';let items=[];try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))items=saved.filter(x=>x&&typeof x.url==='string'&&/^https?:/.test(x.url)&&typeof x.title==='string');}catch{}
const tools=document.createElement('div');tools.className='pn-h6__wishlist-tools';const open=document.createElement('button');open.type='button';open.className='pn-h6__wishlist-open';tools.append(open);root.querySelector('.pn-h6__shopping .pn-commerce__header')?.append(tools);
const persist=()=>{try{localStorage.setItem(key,JSON.stringify(items));status.textContent='';}catch{status.textContent='Your browser could not save this list. It will remain available while this page is open.';}};
const sync=()=>{const label='My Wishlist ('+items.length+')';if(open.textContent!==label)open.textContent=label;shop.querySelectorAll('.pn-h6__save').forEach(b=>{const yes=items.some(x=>x.url===b.dataset.url);b.setAttribute('aria-pressed',String(yes));b.setAttribute('aria-label',(yes?'Remove ':'Save ')+b.dataset.title+(yes?' from wishlist':' to wishlist'));});};
const render=()=>{list.replaceChildren();if(!items.length){const p=document.createElement('p');p.textContent='Save something you love using the bookmark on a shopping card.';list.append(p);}items.forEach(item=>{const a=document.createElement('article'),image=document.createElement('img'),body=document.createElement('div'),brand=document.createElement('p'),h=document.createElement('h3'),link=document.createElement('a'),price=document.createElement('p'),remove=document.createElement('button');image.src=item.image;image.alt=item.title;brand.textContent=item.brand;link.href=item.url;link.rel='sponsored noopener';link.textContent=item.title;h.append(link);price.textContent=item.price;remove.type='button';remove.textContent='Remove';remove.addEventListener('click',()=>{items=items.filter(x=>x.url!==item.url);persist();sync();render();});body.append(brand,h,price,remove);a.append(image,body);list.append(a);});};
open.addEventListener('click',()=>{render();dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());
const enhance=()=>{shop.querySelectorAll('.tpe-shop-card').forEach(card=>{if(card.querySelector('.pn-h6__save'))return;const media=card.querySelector('.tpe-shop-card__media'),link=card.querySelector('.tpe-shop-card__destination, .pn-commerce-cta'),title=card.querySelector('h3')?.textContent.trim();if(!media||!link||!title)return;const b=document.createElement('button');b.type='button';b.className='pn-h6__save';b.dataset.url=link.href;b.dataset.title=title;b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4H19V21L12 17L5 21Z"/></svg>';b.addEventListener('click',()=>{if(items.some(x=>x.url===link.href))items=items.filter(x=>x.url!==link.href);else items.push({url:link.href,title,brand:card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent.trim()||'',price:card.querySelector('.tpe-shop-card__price')?.textContent.trim()||'',image:card.querySelector('img')?.src||''});persist();sync();});const bookmarkRow=document.createElement('div');bookmarkRow.className='pn-h6__bookmark-row';bookmarkRow.append(b);card.querySelector('.tpe-shop-card__copy')?.prepend(bookmarkRow);});sync();};
new MutationObserver(enhance).observe(shop,{childList:true,subtree:true});enhance();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-home-editorial-v7"] && !Shopify.designMode) return;
  try {
    
(() => {
 const host=document.getElementById('pn-editorial-home-v7'); if(!host) return;
 const shopping=host.querySelector('.pn-h7__shopping'); if(!shopping) return;
 const transform=()=>{
  const disclosure=shopping.querySelector('.pn-commerce__disclosure');
  if(disclosure) { const text=shopping.querySelector('.pn-h7__disclosure-source').textContent; if(disclosure.textContent!==text) disclosure.textContent=text; }
  shopping.querySelectorAll('.tpe-shop-card:not([data-hp-refined])').forEach(card=>{
   card.dataset.hpRefined='true';
   const media=card.querySelector('.tpe-shop-card__media'); if(!media) return;
   const brand=card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent?.trim()||'';
   const title=card.querySelector('h3')?.textContent?.trim()||'';
   const rationale=card.querySelector('.tpe-shop-card__why');
   const note=Array.from(rationale?.querySelectorAll('p')||[]).filter(p=>!p.classList.contains('tpe-shop-card__why-heading')).map(p=>p.textContent.trim()).join(' ');
   const overlay=document.createElement('div'); overlay.className='pn-h7__rollover';
   if(brand){ const b=document.createElement('p');b.className='pn-h7__product-brand';b.textContent=brand;overlay.append(b); }
   const h=document.createElement('h3');h.textContent=title;overlay.append(h);
   if(note){const p=document.createElement('p');p.className='pn-h7__product-note';p.textContent=note;overlay.append(p);}
   media.append(overlay);
   const details=document.createElement('details');details.className='pn-h7__selection-details';
   const summary=document.createElement('summary');summary.textContent=shopping.dataset.detailLabel;details.append(summary,overlay.cloneNode(true));card.append(details);
  });
 };
 const observer=new MutationObserver(transform);observer.observe(shopping,{childList:true,subtree:true});transform();
})();

(()=>{
const root=document.getElementById('pn-editorial-home-v7');if(!root)return;
const shop=root.querySelector('.pn-h7__shopping'),dialog=root.querySelector('.pn-h7__wishlist-dialog'),list=dialog.querySelector('.pn-h7__wishlist-items'),status=dialog.querySelector('[role=status]');
const key='pn-wishlist-preview-v1';let items=[];try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))items=saved.filter(x=>x&&typeof x.url==='string'&&/^https?:/.test(x.url)&&typeof x.title==='string');}catch{}
const tools=document.createElement('div');tools.className='pn-h7__wishlist-tools';const open=document.createElement('button');open.type='button';open.className='pn-h7__wishlist-open';tools.append(open);root.querySelector('.pn-h7__shopping .pn-commerce__header')?.append(tools);
const persist=()=>{try{localStorage.setItem(key,JSON.stringify(items));status.textContent='';}catch{status.textContent='Your browser could not save this list. It will remain available while this page is open.';}};
const sync=()=>{const label='My Wishlist ('+items.length+')';if(open.textContent!==label)open.textContent=label;shop.querySelectorAll('.pn-h7__save').forEach(b=>{const yes=items.some(x=>x.url===b.dataset.url);b.setAttribute('aria-pressed',String(yes));b.setAttribute('aria-label',(yes?'Remove ':'Save ')+b.dataset.title+(yes?' from wishlist':' to wishlist'));});};
const render=()=>{list.replaceChildren();if(!items.length){const p=document.createElement('p');p.textContent='Save something you love using the bookmark on a shopping card.';list.append(p);}items.forEach(item=>{const a=document.createElement('article'),image=document.createElement('img'),body=document.createElement('div'),brand=document.createElement('p'),h=document.createElement('h3'),link=document.createElement('a'),price=document.createElement('p'),remove=document.createElement('button');image.src=item.image;image.alt=item.title;brand.textContent=item.brand;link.href=item.url;link.rel='sponsored noopener';link.textContent=item.title;h.append(link);price.textContent=item.price;remove.type='button';remove.textContent='Remove';remove.addEventListener('click',()=>{items=items.filter(x=>x.url!==item.url);persist();sync();render();});body.append(brand,h,price,remove);a.append(image,body);list.append(a);});};
open.addEventListener('click',()=>{render();dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());
const enhance=()=>{shop.querySelectorAll('.tpe-shop-card').forEach(card=>{if(card.querySelector('.pn-h7__save'))return;const media=card.querySelector('.tpe-shop-card__media'),link=card.querySelector('.tpe-shop-card__destination, .pn-commerce-cta'),title=card.querySelector('h3')?.textContent.trim();if(!media||!link||!title)return;const b=document.createElement('button');b.type='button';b.className='pn-h7__save';b.dataset.url=link.href;b.dataset.title=title;b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4H19V21L12 17L5 21Z"/></svg>';b.addEventListener('click',()=>{if(items.some(x=>x.url===link.href))items=items.filter(x=>x.url!==link.href);else items.push({url:link.href,title,brand:card.querySelector('.tpe-shop-card__brand, .tpe-shop-card__by')?.textContent.trim()||'',price:card.querySelector('.tpe-shop-card__price')?.textContent.trim()||'',image:card.querySelector('img')?.src||''});persist();sync();});const bookmarkRow=document.createElement('div');bookmarkRow.className='pn-h7__bookmark-row';bookmarkRow.append(b);card.querySelector('.tpe-shop-card__copy')?.prepend(bookmarkRow);});sync();};
new MutationObserver(enhance).observe(shop,{childList:true,subtree:true});enhance();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pn-latest-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('error', function(event) {
    const image = event.target;
    if (image instanceof HTMLImageElement && image.hasAttribute('data-pn-story-image')) {
      image.hidden = true;
      const fallback = image.parentElement.querySelector('.pn-discovery__type');
      if (fallback) fallback.hidden = false;
    }
  }, true);
  document.querySelectorAll('[data-pn-story-image]').forEach(function(image) {
    if (image.complete && image.naturalWidth === 0) {
      image.hidden = true;
      const fallback = image.parentElement.querySelector('.pn-discovery__type');
      if (fallback) fallback.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.innerHTML = '<p>Fetching recommendations...</p>';

        fetch(this.dataset.url)
          .then(response => {
            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              const productGrid = recommendations.querySelector('.grid.product-grid, ul[role="list"]');
              
              if (productGrid) {
                const customGrid = document.createElement('div');
                customGrid.className = 'product-recommendations-grid';
                
                const productCards = productGrid.querySelectorAll('.grid__item, li');
                productCards.forEach(card => {
                  customGrid.appendChild(card);
                });
                
                this.innerHTML = '';
                this.appendChild(customGrid);
              } else {
                this.innerHTML = recommendations.innerHTML;
              }
            } else {
              this.innerHTML = '<p>No recommendations available.</p>';
            }

            if (this.querySelector('.grid__item, li')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            this.innerHTML = '<p>Unable to load recommendations: ' + e.message + '</p>';
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpe-destination"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (root) => {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const seasonLinks = [...root.querySelectorAll('[data-season-link]')];
    const panels = [...root.querySelectorAll('[data-season-panel]')];
    const showSeason = (id) => {
      if (!panels.some(panel => panel.id === id)) return;
      panels.forEach(panel => { panel.hidden = panel.id !== id; });
      seasonLinks.forEach(link => { if(link.hash === '#' + id) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
    };
    const reveal = (hash, focus = false) => {
      let id; try { id = decodeURIComponent(hash.replace(/^#/,'')); } catch { return; }
      const target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      const panel = target.closest('[data-season-panel]');
      if (panel) showSeason(panel.id);
      const containingChapter = target.closest('[data-chapter]');
      if (containingChapter) {
        containingChapter.open = true;
      }
      if (focus && (target.classList.contains('tpe-note') || target.classList.contains('tpe-key-hotel'))) target.focus({ preventScroll:true });
      if (target.matches('[data-chapter]')) {
        target.closest('[data-chapters]').querySelectorAll('[data-chapter]').forEach(chapter => { chapter.open = chapter === target; });
        if (focus) target.querySelector('summary').focus({ preventScroll: true });
      }
      if (focus) target.scrollIntoView({ block:'start', behavior:'instant' });
    };
    if (panels.length) {
      const seasonal = getComputedStyle(document.documentElement).getPropertyValue('--pn-season').trim();
      showSeason(panels.some(panel => panel.id === seasonal) ? seasonal : panels[0].id);
    }
    reveal(location.hash, !!location.hash);
    const onHash = () => reveal(location.hash,true);
    window.addEventListener('hashchange', onHash);
    root.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      if (link.hasAttribute('data-season-link') || link.hasAttribute('data-chapter-link') || link.hasAttribute('data-of-note-link')) {
        event.preventDefault();
        history.pushState(null,'',link.hash);
        reveal(link.hash,true);
      }
    });
    const themeId = root.dataset.themeId;
    root.querySelectorAll('a[href]').forEach(link => {
      if (link.getAttribute('href').startsWith('#')) return;
      const url = new URL(link.href,location.origin);
      if (url.origin === location.origin || url.hostname === 'purelynurtured.co') {
        if (themeId) url.searchParams.set('preview_theme_id',themeId);
        link.setAttribute('href',url.pathname + url.search + url.hash);
      }
    });
    root.addEventListener('shopify:section:unload', () => window.removeEventListener('hashchange',onHash),{ once:true });
  };
  document.querySelectorAll('[data-tpe-travel]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-tpe-travel]').forEach(mount));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpe-master-article"] && !Shopify.designMode) return;
  try {
    
function initTpeMaster(root){root.querySelectorAll('.tpe-master').forEach(story=>{const nav=story.querySelector('.tpe-master__contents');if(nav){const list=nav.querySelector('ul');list.replaceChildren();const headings=story.querySelectorAll('.tpe-master__prose h2');headings.forEach((heading,index)=>{if(!heading.id)heading.id=story.id+'-chapter-'+index;const li=document.createElement('li');const a=document.createElement('a');a.href='#'+heading.id;a.textContent=heading.textContent;li.append(a);list.append(li)});nav.hidden=headings.length<3}const prose=story.querySelector('.tpe-master__original');if(prose){const paragraphs=Array.from(prose.children).filter(n=>n.tagName==='P');const tails=new Map();story.querySelectorAll('[data-after-paragraph]').forEach(module=>{const anchor=paragraphs[Number(module.dataset.afterParagraph)-1];if(!anchor)return;(tails.get(anchor)||anchor).after(module);tails.set(anchor,module)})}})}
initTpeMaster(document);document.addEventListener('shopify:section:load',event=>initTpeMaster(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpe-prc-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-prc-copy]');
  if (!button) return;
  const status = button.parentElement.querySelector('[role="status"]');
  const original = button.textContent;
  let copied = false;
  try { await navigator.clipboard.writeText('692078'); copied = true; }
  catch {
    const input = document.createElement('textarea');
    input.value = '692078';
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(input);
    input.select();
    copied = document.execCommand('copy');
    input.remove();
    button.focus({preventScroll:true});
  }
  if (copied) {
    button.textContent = button.dataset.copied;
    status.textContent = button.dataset.copied;
    setTimeout(() => {button.textContent = original;status.textContent = '';}, 2500);
  } else { status.textContent = button.dataset.error; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpe-resource-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const link = event.target.closest('.tpe-gallery__jump a');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  history.pushState(null, '', link.hash);
  target.focus({preventScroll:true});
  target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
});

  } catch(e) { console.error(e); }
})();
})();
